import React, { useRef } from "react";
import { Helmet } from "react-helmet";

import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";

const TITLE = "DBC | " + Config.SITE_TITLE;
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const PrivacyPolicy = () => {
  return (
    <main className="contact-main-content">
      <Helmet>
        <title>{TITLE}</title>
        <Link rel="canonical" href={CANONICAL}></Link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Adatvédelmi szabályzat</h1>
        </div>
        <div className="contact-content-container w-75">
          <h5>Hatálybalépés dátuma: 25.10.2024</h5>
          <h2 className="contact-color contact-margin-y2">Bevezetés</h2>
          <p>
            A janoszter.com oldalon elkötelezettek vagyunk az Ön adatainak
            védelme és személyes adatainak biztonsága iránt. Ez az Adatvédelmi
            Szabályzat ismerteti, hogyan gyűjtjük, használjuk fel és védjük a
            hírlevelünkre való feliratkozáskor megadott személyes adatokat. A
            feliratkozással Ön elfogadja a jelen szabályzatban foglalt
            feltételeket.
          </p>
          <h2 className="contact-color contact-margin-y2">Adatkezelés</h2>
          <p>
            Az Ön személyes adataiért felelős adatkezelő a janoszter.com. Ha
            bármilyen kérdése vagy aggálya merülne fel az Adatvédelmi
            Szabályzattal kapcsolatban, a következő elérhetőségeken veheti fel
            velünk a kapcsolatot:
          </p>
          <p>Email: info@janoseszter.com</p>
          <p>Phone: +36 30 5440616</p>
          <p>Address: 3100 Salgótarján, Árpád út 9. Hungary, </p>
          <h2 className="contact-color contact-margin-y2">
            Information We Collect
          </h2>

          <h2 className="contact-color contact-margin-y2">Adatbiztonság.</h2>
          <p>
            Komolyan vesszük személyes adatainak biztonságát. Megfelelő
            technikai és szervezési intézkedéseket hajtunk végre adatainak
            jogosulatlan hozzáférés, elvesztés vagy visszaélés elleni védelme
            érdekében.
          </p>
          <h2 className="contact-color contact-margin-y2">
            Harmadik féllel való megosztás
          </h2>
          <p>
            Személyes adatait nem adjuk el és nem adjuk bérbe harmadik feleknek.
            Azonban megoszthatjuk adatait megbízható szolgáltatókkal, akik
            segítenek nekünk a hírlevél kézbesítésében vagy weboldalunk
            üzemeltetésében, szigorú titoktartási kötelezettségek betartása
            mellett.
          </p>
          <h2 className="contact-color contact-margin-y2">
            Adatvédelmi irányelvek módosításai
          </h2>
          <p>
            Időről időre frissíthetjük ezt az Adatvédelmi Szabályzatot.
            Amennyiben jelentős változtatásokat hajtunk végre, e-mailben vagy
            weboldalunkon közzétett értesítéssel értesítjük Önt. Kérjük,
            rendszeresen tekintse át ezt az oldalt az adatvédelmi
            gyakorlatunkkal kapcsolatos legfrissebb információkért.
          </p>
          <h2 className="contact-color contact-margin-y2">
            Lépjen kapcsolatba velünk
          </h2>
          <p>
            Ha bármilyen kérdése vagy aggálya van az Adatvédelmi Szabályzattal
            vagy azzal kapcsolatban, hogyan kezeljük az Ön személyes adatait,
            kérjük, vegye fel velünk a kapcsolatot a következő elérhetőségeken:
          </p>
          <p>Email: info@janoseszter.com</p>
          <p>Phone: +36 30 5440616</p>
          <p>Address: 3100 Salgótarján, Árpád út 9. Hungary, </p>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
